import React, { createContext, useReducer } from 'react'
import { API_URL } from '../../shared/actions'
import { uploadHeaderReducer } from '../reducer/uploadHeaderReducer'

import configurationReducer from './ConfigurationReducer'

const initialState = {
  zones: false,
  loading: true,
  channelTypes: false,
  targetTypes: false,
  templateCategory: false,
  targets: false,
  positions: false,
  regions: false,
  states: false,
  district: false,
  leaveType: false,
  leadType: false,
  employeeAttendance: false,
  city: false,
  areas: false,
  stores: false,
  totalLeaves: false,
  taxes: false,
  leadSources: false,
  customerTypes: false,
  salesChannelTypes: false,
  leadTypeConversions: false,
  schemes: false,
  permissions: false,
  holidays: false,
}

export const ConfigurationContext = createContext(initialState)

export const ConfigurationContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(configurationReducer, initialState)
  const [uploadHeaderState, uploadHeaderDispatch] = useReducer(uploadHeaderReducer, { uploadHeaders: false, loading: false })
  const {
    UPLOAD_HEADER: { GET_ALL_UPLOAD_HEADERS, ADD_UPLOAD_HEADER, EDIT_UPLOAD_HEADER, DELETE_MANY_UPLOAD_HEADER },
  } = API_URL

  function getAllZones(zones) {
    dispatch({
      type: 'GET_ALL_ZONES',
      payload: zones,
    })
  }

  function addZone(zone) {
    dispatch({
      type: 'ADD_ZONE',
      payload: zone,
    })
  }
  function getAllPermissions(data) {
    dispatch({
      type: 'GET_ALL_PERMISSIONS',
      payload: data,
    })
  }
  function getAllUploadHeaders(data) {
    uploadHeaderDispatch({
      type: GET_ALL_UPLOAD_HEADERS,
      payload: data,
    })
  }

  function deletePermission(id) {
    console.log(id)
    dispatch({
      type: 'DELETE_PERMISSION',
      payload: id,
    })
  }
  function addUploadHeader(data) {
    uploadHeaderDispatch({
      type: ADD_UPLOAD_HEADER,
      payload: data,
    })
  }
  function editUploadHeader(data) {
    uploadHeaderDispatch({
      type: EDIT_UPLOAD_HEADER,
      payload: data,
    })
  }
  function deleteUploadHeader(data) {
    uploadHeaderDispatch({
      type: DELETE_MANY_UPLOAD_HEADER,
      payload: data,
    })
  }
  function addRegion(data) {
    dispatch({
      type: 'ADD_REGION',
      payload: data,
    })
  }
  function addState(data) {
    dispatch({
      type: 'ADD_STATE',
      payload: data,
    })
  }
  function addDistrict(data) {
    dispatch({
      type: 'ADD_DISTRICT',
      payload: data,
    })
  }
  function addCity(data) {
    dispatch({
      type: 'ADD_CITY',
      payload: data,
    })
  }
  function addArea(data) {
    dispatch({
      type: 'ADD_AREA',
      payload: data,
    })
  }
  function addStore(data) {
    dispatch({
      type: 'ADD_STORE',
      payload: data,
    })
  }

  function editRegion(data) {
    dispatch({
      type: 'EDIT_REGION',
      payload: data,
    })
  }
  function editState(data) {
    dispatch({
      type: 'EDIT_STATE',
      payload: data,
    })
  }
  function editDistrict(data) {
    dispatch({
      type: 'EDIT_DISTRICT',
      payload: data,
    })
  }
  function editCity(data) {
    dispatch({
      type: 'EDIT_CITY',
      payload: data,
    })
  }
  function editArea(data) {
    dispatch({
      type: 'EDIT_AREA',
      payload: data,
    })
  }
  function editStore(data) {
    dispatch({
      type: 'EDIT_STORE',
      payload: data,
    })
  }

  function editZone(zone) {
    dispatch({
      type: 'EDIT_ZONE',
      payload: zone,
    })
  }

  function removeZone(id) {
    dispatch({
      type: 'REMOVE_ZONE',
      payload: id,
    })
  }

  function getAllChannelTypes(channelTypes) {
    dispatch({
      type: 'GET_ALL_CHANNEL_TYPES',
      payload: channelTypes,
    })
  }

  function addChannelType(channelType) {
    dispatch({
      type: 'ADD_CHANNEL_TYPE',
      payload: channelType,
    })
  }

  function editChannelType(channelType) {
    dispatch({
      type: 'EDIT_CHANNEL_TYPE',
      payload: channelType,
    })
  }

  function removeChannelType(id) {
    dispatch({
      type: 'REMOVE_CHANNEL_TYPE',
      payload: id,
    })
  }

  // TARGET TYPES
  function getAllTargetTypes(targetTypes) {
    dispatch({
      type: 'GET_ALL_TARGET_TYPES',
      payload: targetTypes,
    })
  }

  function addTargetType(targetType) {
    dispatch({
      type: 'ADD_TARGET_TYPE',
      payload: targetType,
    })
  }

  function editTargetType(targetType) {
    dispatch({
      type: 'EDIT_TARGET_TYPE',
      payload: targetType,
    })
  }

  function removeTargetType(id) {
    dispatch({
      type: 'REMOVE_TARGET_TYPE',
      payload: id,
    })
  }

  // TEMPLATE CATEGORY
  function getAllTemplateCategory(data) {
    dispatch({
      type: 'GET_ALL_TEMPLATE_CATEGORY',
      payload: data,
    })
  }

  function addTemplateCategory(data) {
    dispatch({
      type: 'ADD_TEMPLATE_CATEGORY',
      payload: data,
    })
  }

  function editTemplateCategory(data) {
    dispatch({
      type: 'EDIT_TEMPLATE_CATEGORY',
      payload: data,
    })
  }

  function removeTemplateCategory(id) {
    dispatch({
      type: 'REMOVE_TEMPLATE_CATEGORY',
      payload: id,
    })
  }

  // TARGET
  function getAllTarget(data) {
    dispatch({
      type: 'GET_ALL_TARGET',
      payload: data,
    })
  }

  function addTarget(data) {
    dispatch({
      type: 'ADD_TARGET',
      payload: data,
    })
  }

  function editTarget(data) {
    dispatch({
      type: 'EDIT_TARGET',
      payload: data,
    })
  }

  function removeTarget(id) {
    dispatch({
      type: 'REMOVE_TARGET',
      payload: id,
    })
  }
  function removePosition(id) {
    dispatch({
      type: 'REMOVE_POSITION',
      payload: id,
    })
  }

  // REGIONS

  function getAllRegion(data) {
    dispatch({
      type: 'GET_ALL_REGION',
      payload: data,
    })
  }

  function removeRegion(id) {
    dispatch({
      type: 'REMOVE_REGION',
      payload: id,
    })
  }
  function getAllLeadTypeConversion(data) {
    dispatch({
      type: 'GET_ALL_LEADTYPE_CONVERSION',
      payload: data,
    })
  }

  function removeLeadTypeConversion(id) {
    dispatch({
      type: 'REMOVE_LEADTYPE_CONVERSION',
      payload: id,
    })
  }

  //  function getAllZone(data) {
  //   dispatch({
  //     type: 'GET_ALL_ZONE',
  //     payload: data,
  //   })
  // }
  function getAllStates(data) {
    dispatch({
      type: 'GET_ALL_STATES',
      payload: data,
    })
  }
  function getAllCity(data) {
    dispatch({
      type: 'GET_ALL_CITY',
      payload: data,
    })
  }
  function getAllPosition(data) {
    dispatch({
      type: 'GET_ALL_POSITION',
      payload: data,
    })
  }

  function getAllDistrict(data) {
    dispatch({
      type: 'GET_ALL_DISTRICT',
      payload: data,
    })
  }
  function getAllArea(data) {
    dispatch({
      type: 'GET_ALL_AREA',
      payload: data,
    })
  }
  function getAllStore(data) {
    dispatch({
      type: 'GET_ALL_STORE',
      payload: data,
    })
  }
  function removeArea(data) {
    dispatch({
      type: 'REMOVE_AREA',
      payload: data,
    })
  }
  function removeStore(data) {
    dispatch({
      type: 'REMOVE_STORE',
      payload: data,
    })
  }
  function removeState(data) {
    dispatch({
      type: 'REMOVE_STATE',
      payload: data,
    })
  }
  function removeDistrict(data) {
    dispatch({
      type: 'REMOVE_DISTRICT',
      payload: data,
    })
  }
  function removeCity(data) {
    dispatch({
      type: 'REMOVE_CITY',
      payload: data,
    })
  }
  function getAllLeaveType(data) {
    dispatch({
      type: 'GET_ALL_LEAVETYPE',
      payload: data,
    })
  }

  function getAllLeadType(data) {
    dispatch({
      type: 'GET_ALL_LEADTYPE',
      payload: data,
    })
  }
  function getAllTotalLeave(data) {
    dispatch({
      type: 'GET_ALL_TOTAL_LEAVE',
      payload: data,
    })
  }

  function getEmployeeAttendances(data) {
    dispatch({
      type: 'GET_EMPLOYEE_ATTENDANCE',
      payload: data,
    })
  }

  function removeEmployeeAttendnace(id) {
    dispatch({
      type: 'REMOVE_EMPLOYEE_ATTENDANCE',
      payload: id,
    })
  }

  function getAllTax(data) {
    dispatch({
      type: 'GET_ALL_TAX',
      payload: data,
    })
  }

  function removeTax(id) {
    dispatch({
      type: 'REMOVE_TAX',
      payload: id,
    })
  }

  function getAllLeadSource(data) {
    dispatch({
      type: 'GET_ALL_LEADSOURCE',
      payload: data,
    })
  }

  function removeLeadSource(id) {
    dispatch({
      type: 'REMOVE_LEADSOURCE',
      payload: id,
    })
  }
  function getAllSalesChannelType(data) {
    dispatch({
      type: 'GET_ALL_SALES_CHANNEL_TYPE',
      payload: data,
    })
  }

  function removeSalesChannelType(id) {
    dispatch({
      type: 'REMOVE_SALES_CHANNEL_TYPE',
      payload: id,
    })
  }


  function getNewHolidays(data) {
    dispatch({
      type: 'GET_ALL_HOLIDAY',
      payload: data,
    })
  }

  function removeHoliday(id) {
    dispatch({
      type: 'REMOVE_HOLIDAY',
      payload: id,
    })
  }

  function getAllCustomerType(data) {
    dispatch({
      type: 'GET_ALL_CUSTOMERTYPE',
      payload: data,
    })
  }

  function removeCustomerType(id) {
    dispatch({
      type: 'REMOVE_CUSTOMERTYPE',
      payload: id,
    })
  }
  function getAllScheme(data) {
    dispatch({
      type: 'GET_ALL_SCHEME',
      payload: data,
    })
  }

  function removeScheme(id) {
    dispatch({
      type: 'REMOVE_SCHEME',
      payload: id,
    })
  }

  function removeTotalLeave(id) {
    dispatch({
      type: 'REMOVE_TOTAL_LEAVE',
      payload: id,
    })
  }

  function deleteLeaveType(id) {
    dispatch({
      type: 'REMOVE_LEAVETYPE',
      payload: id,
    })
  }
  function deleteLeadType(id) {
    dispatch({
      type: 'REMOVE_LEADTYPE',
      payload: id,
    })
  }
  function deleteLead(id) {
    dispatch({
      type: 'REMOVE_LEAD',
      payload: id,
    })
  }

  console.log({ state })

  return (
    <ConfigurationContext.Provider
      value={{
        getNewZones: getAllZones,
        zones: state.zones,
        addNewZone: addZone,
        addNewRegion: addRegion,
        addNewState: addState,
        addNewDistrict: addDistrict,
        addNewCity: addCity,
        addNewArea: addArea,
        addNewStore: addStore,
        editNewRegion: editRegion,
        editNewState: editState,
        editNewDistrict: editDistrict,
        editNewCity: editCity,
        editNewArea: editArea,
        editNewStore: editStore,
        editNewZone: editZone,
        deleteNewRegion: removeRegion,
        deleteNewZones: removeZone,
        deleteNewState: removeState,
        deleteNewDistrict: removeDistrict,
        deleteNewCity: removeCity,
        deleteNewArea: removeArea,
        deleteNewStore: removeStore,
        getNewChannelTypes: getAllChannelTypes,
        channelTypes: state.channelTypes,
        addNewChannelType: addChannelType,
        editNewChannelType: editChannelType,
        deleteNewChannelType: removeChannelType,
        targetTypes: state.targetTypes,
        getNewTargetTypes: getAllTargetTypes,
        addNewTargetType: addTargetType,
        editNewTargetType: editTargetType,
        deleteNewTargetType: removeTargetType,
        templateCategory: state.templateCategory,
        getNewTemplateCategory: getAllTemplateCategory,
        addNewTemplateCategory: addTemplateCategory,
        editNewTemplateCategory: editTemplateCategory,
        deleteNewTemplateCategory: removeTemplateCategory,
        targets: state.targets,
        getNewTarget: getAllTarget,
        addNewTarget: addTarget,
        editNewTarget: editTarget,
        deleteNewTarget: removeTarget,
        deleteNewPosition: removePosition,
        positions: state.positions,
        getNewPosition: getAllPosition,
        getNewRegion: getAllRegion,
        regions: state.regions,
        // getNewZone: getAllZone,
        zone: state.zone,
        getNewStates: getAllStates,
        states: state.states,
        getNewDistrict: getAllDistrict,
        district: state.district,
        getNewLeaveType: getAllLeaveType,
        deleteNewLeaveType: deleteLeaveType,
        deleteNewLeadType: deleteLeadType,
        leaveType: state.leaveType,
        getNewLeadType: getAllLeadType,
        getNewCity: getAllCity,
        city: state.city,
        leadType: state.leadType,
        getNewEmployeeAttendances: getEmployeeAttendances,
        employeeAttendance: state.employeeAttendance,
        deleteNewEmployeeAttendnace: removeEmployeeAttendnace,
        getNewArea: getAllArea,
        areas: state.areas,
        getNewStore: getAllStore,
        stores: state.stores,
        getNewTotalLeave: getAllTotalLeave,
        deleteNewTotalLeave: removeTotalLeave,
        totalLeaves: state.totalLeaves,
        getNewTax: getAllTax,
        deleteNewTax: removeTax,
        taxes: state.taxes,
        getNewLeadSource: getAllLeadSource,
        deleteNewLeadSource: removeLeadSource,
        leadSources: state.leadSources,
        getNewCustomerType: getAllCustomerType,
        deleteNewCustomerType: removeCustomerType,
        customerTypes: state.customerTypes,
        getNewLeadTypeConversion: getAllLeadTypeConversion,
        deleteNewLeadTypeConversion: removeLeadTypeConversion,
        leadTypeConversions: state.leadTypeConversions,
        getNewSalesChannelType: getAllSalesChannelType,
        deleteNewSalesChannelType: removeSalesChannelType,
        salesChannelTypes: state.salesChannelTypes,
        getNewScheme: getAllScheme,
        deleteNewScheme: removeScheme,
        schemes: state.schemes,
        deleteNewLead: deleteLead,
        getNewPermissions: getAllPermissions,
        deleteNewPermission: deletePermission,
        permissions: state.permissions,
        getNewUploadHeaders: getAllUploadHeaders,
        addNewUploadHeader: addUploadHeader,
        editNewUploadHeader: editUploadHeader,
        deleteNewUploadHeader: deleteUploadHeader,
        uploadHeaders: uploadHeaderState.uploadHeaders,
        holidays: state.holidays,
        getNewHolidays:getNewHolidays,
        removeHoliday: removeHoliday,
      }}
    >
      {children}
    </ConfigurationContext.Provider>
  )
}
